<template>
<div ref="platshopAdd">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增平台账号</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="shoplist.length > 1 ? shoplist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addpetmodel">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回系统管理员</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in shoplist" :key="index">
            <div class="TTL-form-submit-box-title">商户号-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="delpet(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">账号LOGO</label>
                    <wcupload :option="{size:'large', phototype:'system'}" :value="item.logo" 
                        @finish="(val)=> {
                            item.avar=val.logo;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">账号版本<i>*</i></label>
                    <div class="TTL-select">
                        <el-select v-model="item.level" placeholder="请选择" clearable filterable>
                            <el-option v-for="(item,index) in levellist" :key="index" :label="item.levelname" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">账号名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.shopname" placeholder="请输入账号名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">注册手机<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.phone" placeholder="请输入注册手机" @change="[changephone(index),SaveDataToBrowser]" clearable />
                    </div>
                </el-form-item>
                 <el-form-item>
                    <label class="TTL-form-label">注册人<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入注册人" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">登录密钥<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.password" placeholder="请输入登录密钥" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item style="padding:20px 0">
                    <div class="TTL-button TTL-btn-option">
                    <el-button @click="addshopsub(index)">新增子商户号</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option">
                    <el-button type="del" @click="delshopsub(index)">清空子商户号</el-button>
                    </div>
                </el-form-item>
                <div class="TTL-table">
                    <el-table :data="item.othershop" stripe="true">
                        <el-table-column label="商户logo" align="left">
                            <template #default="otherscope">
                                <wcupload :option="{size:'middle', phototype:'system'}" :value="otherscope.row.logo" 
                                    @finish="(val)=> {
                                        otherscope.row.logo=val.url;
                                    }" 
                                />
                            </template>
                        </el-table-column>
                        <el-table-column label="子商户注册手机" align="left">
                            <template #default="otherscope">
                                <div class="TTL-input width200 TTL-form-input">
                                    <el-input v-model="otherscope.row.phone" placeholder="请输入子商户注册手机" @change="SaveDataToBrowser" clearable readonly disabled />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="子商户名称" align="left">
                            <template #default="otherscope">
                                <div class="TTL-input width200 TTL-form-input">
                                    <el-input v-model="otherscope.row.shopname" placeholder="请输入商户名称" @change="SaveDataToBrowser" clearable />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="子商户版本" align="left">
                            <template #default="otherscope">
                                <div class="TTL-select">
                                    <el-select v-model="otherscope.row.level" placeholder="请选择" clearable filterable @change="SaveDataToBrowser">
                                    <el-option v-for="(item,index) in levellist" :key="index" :label="item.levelname" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template #default="otherscope">
                                 <div class="TTL-button TTL-btn-option">
                                <el-button type="del" @click="delsubshop(index,otherscope.$index)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,                                            //单次新增限制
            uploadimageIndex:'',                                     //获取当前上传图片的序号
            uploadsubIndex:'',                                       //获取当前上传的子商户的序号
            shoplist:[{logo:'',level:'',shopname:'',name:'',phone:'',password:'',othershop:[]}],   //账号信息列表
            levellist:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetLevellist(); //获取账号版本信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.ParseDataFromBrowser();
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.shoplist.length;i++) data.push(this.shoplist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.platshopAdd;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_SHOP.ADD_PLATFORM_SHOP({managerdata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },



        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有账号信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },

        
        /** 新增品种模板信息 **/
        addpetmodel() {
            if(this.shoplist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单次添加账号数量请最多不要超过'+this.addlimit+'个',type:'warning'});
                return false;
            }

            var shop={logo:'',level:'',shopname:'',name:'',phone:'',password:'',othershop:[]};
            this.shoplist.push(shop);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 删除单个品种信息 **/
        delpet(index) {
            this.shoplist.splice(index,1);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 新增子商户号信息 **/
        addshopsub(index) {
            this.shoplist[index].othershop.push({logo:'',level:'',shopname:'',phone:''});
        },


        /** 清空子商户号信息 **/
        delshopsub(index) {
            this.shoplist[index].othershop=[];
        },

        /** 删除子商户号信息 **/
        delsubshop(pindex,sindex) {
            this.shoplist[pindex].othershop.splice(sindex,1);
        },

        /** 修改商户手机号码 **/
        changephone(index) {
            var phone=this.shoplist[index].phone;
            var subobj=this.shoplist[index].othershop;
            for(var i in subobj) subobj[i].phone=phone;
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取账号版本信息 **/
        GetLevellist() {
            var param={p:1,rollpage:10000};
            INTERFACE_MODEL_SHOP.GET_PLATFORM_Level(param).then((res) => {
                 if(res.status > 0) return false;
                 this.levellist=res.data.list;
            });
        },

        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.shoplist);
            localStorage.setItem('addplatshopdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addplatshopdata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.shoplist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'平台账号管理',labelentry:'PlatFormShop',components:'PlatFormShop',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.shoplist=[];
            var managerinfos={logo:'',level:'',shopname:'',name:'',phone:'',password:'',othershop:[]};
            var data=managerinfos;
            this.shoplist.push(data);
            this.SaveDataToBrowser();
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
</style>